import { render, staticRenderFns } from "./CorrectionCompanyDataModal.vue?vue&type=template&id=caa09fe2&scoped=true&"
import script from "./CorrectionCompanyDataModal.vue?vue&type=script&lang=ts&"
export * from "./CorrectionCompanyDataModal.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectionCompanyDataModal.vue?vue&type=style&index=0&id=caa09fe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa09fe2",
  null
  
)

export default component.exports